


































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import GLoading from '@/components/GLoading.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import GJgrowActivityListTitleInput from '@/views/GJgrowActivity/GJgrowActivityListTitleInput.vue';

@Component({
  name: 'GJgrowActivity',
  components: {
    GLoading,
    GTitleBar,
    GCustomBreadCrumb,
    GOptionalIcon,
    GJgrowActivityListTitleInput,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GJgrowActivity extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  listColumn: object[] = [];
  lazy: boolean = false;
  processing: boolean = false;
  size: number = 24;

  async mounted() {
    await activityModule.fetchActivities();

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: 'アクティビティ設定' },
    ];
    this.createColumn();
    this.lazy = true;
  }

  get isProcessing(): boolean {
    return this.processing;
  }

  get activities() {
    return activityModule.activities;
  }

  rowDisableColor(row: Activity): string {
    if (row.companyID === null) {
      return 'invalid-row';
    }
    return 'no-setting-row';
  }

  // 編集可否
  // JTB作成のものは編集不可（作成した CompanyID が null）
  isDisabled(row: Activity) {
    return !(row.companyID === null);
  }

  createColumn(): void {
    this.listColumn = [this.columnCustomCompetencyName, this.columnCompetencies, this.columnActions];
  }

  handleDeleteConfirm(row: Activity) {
    let config = {
      title: `${row.activityName}を削除しますか？`,
      onOk: () => {
        this.loadingPage(
          () => {
            activityModule.deleteActivity(row.activityID).then(() => {
            });
          },
          () => {
            window.location.reload();
          },
          3000
        );
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  get columnCustomCompetencyName(): any {
    return {
      title: 'アクティビティ名',
      slot: 'activity-name',
      width: 320,
    };
  }

  get columnCompetencies(): any {
    return {
      title: 'アイテム',
      slot: 'selected-item',
    };
  }

  get columnActions(): any {
    return {
      title: '操作',
      slot: 'actions',
      align: 'center',
      width: 50,
    };
  }
}
